import { useLocalStorage } from "@mantine/hooks";
import { createContext, useContext, useState } from "react";
const AdBuilderContext = createContext();

export const AdBuilderProvider = ({ children, query, mutation }) => {

    const [options, setOptions] = useState();
    const queryData = query?.data?.[0] ?? query?.data ?? {};
    const [activeTabSlide, setActiveTabSlide] = useState('ai');
    const [aiSuggestions, setAiSuggestions] = useLocalStorage({
        key: 'ai-suggestions-' + queryData?.id,
        defaultValue: {}
    });

    return (
        <AdBuilderContext.Provider value={{ options, setOptions, activeTabSlide, setActiveTabSlide, aiSuggestions, setAiSuggestions, query: { ...query, data: queryData }, mutation, templateAlias: queryData?.ad_banner_formats?.[0]?.tech_type ?? '' }}>
            {
                query?.isFetched && (children)
            }
        </AdBuilderContext.Provider>
    );
};

export const useAdBuilder = () => useContext(AdBuilderContext);

export const mergeGallerySuggestions = (prev, next) => {
    const isUrl = (src) => typeof src === 'string' && src.length > 0;
    const existing = Array.isArray(prev) ? prev.filter(isUrl) : [];
    const incoming = Array.isArray(next) ? next.filter(isUrl) : [];

    return [...new Set([...existing, ...incoming])];
};
